import React, { useMemo, useRef } from 'react';
import useCanvasEngine from './useCanvasEngine';
import { getCanvasPayloadsFromStructure, resolveCanvasSize } from './layoutFactory';

function CanvasSlide({ payload, showHeader = false, scale = 0.24 }) {
  const canvasElementRef = useRef(null);
  useCanvasEngine(canvasElementRef, payload.canvasData);

  const { width, height } = useMemo(() => resolveCanvasSize(payload.canvasData), [payload.canvasData]);

  return (
    <article className="creative-preview-bubble__slide">
      {showHeader ? <header className="creative-preview-bubble__slide-header">{payload.title}</header> : null}
      <div className="creative-preview-bubble__slide-body creative-preview-bubble__slide-body--canvas">
        <canvas
          ref={canvasElementRef}
          width={width}
          height={height}
          style={{ width: `${Math.round(width * scale)}px`, height: `${Math.round(height * scale)}px` }}
        />
      </div>
    </article>
  );
}

export default function CreativeCanvasEngine({ structure, scale = 0.24 }) {
  const payloads = useMemo(() => getCanvasPayloadsFromStructure(structure), [structure]);
  if (!payloads.length) return null;

  const isCarousel = payloads.length > 1;
  if (!isCarousel) {
    return (
      <div className="creative-preview-bubble creative-preview-bubble--canvas">
        <CanvasSlide payload={payloads[0]} scale={scale} />
      </div>
    );
  }

  return (
    <div className="creative-preview-bubble creative-preview-bubble--carousel">
      {payloads.map((payload) => (
        <CanvasSlide key={payload.id} payload={payload} showHeader scale={scale} />
      ))}
    </div>
  );
}
